import styled from "@emotion/styled"
import { spacingFluidMd, spacingFluidXl, spacingStatic2Xs } from "@porsche-design-system/components-react/emotion"
import { Grid, GridItem, Skeleton } from "src/components"

export const StandardEquipmentSkeleton = () => (
	<StyledGrid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
		<GridItem size={{ base: 12, s: 6 }}>
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
		</GridItem>
		<GridItem size={{ base: 12, s: 6 }}>
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
		</GridItem>
	</StyledGrid>
)

const StyledGrid = styled(Grid)`
	row-gap: calc(2 * ${spacingStatic2Xs});
`
